// extracted by mini-css-extract-plugin
export default {"button":"NewReleaseForm_button__vu5KV","buttonContainer":"NewReleaseForm_buttonContainer__rtjIc"};